export const REQUEST_REGISTRY_DETAILS = 'zola/nav/REQUEST_REGISTRY_DETAILS';
export const RECEIVE_REGISTRY_DETAILS = 'zola/nav/RECEIVE_REGISTRY_DETAILS';
export const TOGGLE_REGISTRY_PUBLISHED = 'zola/nav/TOGGLE_REGISTRY_PUBLISHED';
export const HAS_SHIPPING_ADDRESS = 'zola/nav/HAS_SHIPPING_ADDRESS';
export const REQUEST_EXCLUDED_REGISTRY_PRODUCTS = 'REQUEST_EXCLUDED_REGISTRY_PRODUCTS';
export const RECEIVE_EXCLUDED_REGISTRY_PRODUCTS = 'RECEIVE_EXCLUDED_REGISTRY_PRODUCTS';
export const UPDATE_REGISTRY_SETTINGS = 'UPDATE_REGISTRY_SETTINGS';
